// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash/fp';

// Utils
import { pluralise } from '../../../../common/utils/stringUtil';
import { length } from '../../../../common/utils/immutableHelper';

// Components
import SearchFormInput from './SearchFormInput';

// Styles
import './SearchForm.scss';

const SearchForm = React.forwardRef(function SearchForm(props, ref) {
    const { searchQuery, searchResultsList, loading } = props;

    const resultsCount = length(searchResultsList);

    const searchInfo =
        (isEmpty(searchQuery) && 'Recently viewed') ||
        (loading && 'Searching...') ||
        `${resultsCount} ${pluralise('result', resultsCount)}`;

    return (
        <div className="SearchForm">
            <SearchFormInput {...props} ref={ref} />
            <div className="search-info">{searchInfo}</div>
        </div>
    );
});

SearchForm.propTypes = {
    searchResultsList: PropTypes.array,
    searchQuery: PropTypes.string,
    loading: PropTypes.bool,
};

export default SearchForm;
